import script from "./FormPage.vue?vue&type=script&setup=true&lang=js"
export * from "./FormPage.vue?vue&type=script&setup=true&lang=js"

import "./FormPage.vue?vue&type=style&index=0&id=c63c00c6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c63c00c6"]])

export default __exports__